/* jshint esversion: 6 */

export const Themes = [
  {
    "name": "Holy family in Egypt",
    "url": "https://raw.githubusercontent.com/paths-erc/docs/master/raw-data/gis/sacra-famiglia-in-egitto/sacra-famiglia-in-egitto.geojson",
    "info": "https://docs.paths-erc.eu/gis/vectors"
  },
  {
    "name": "Coptic monasteries with coordinates",
    "url": "https://raw.githubusercontent.com/paths-erc/docs/master/raw-data/gis/coptic-monasteries-with-coordinates/coptic-monasteries-with-coordinates.geojson",
    "info": "https://docs.paths-erc.eu/gis/vectors"
  }
];

export const SiteMapsList = [
  "paths.places.16-Elephantine/BGQ6JNX2-186",
  "paths.places.16-Elephantine/BGQ6JNX2-77",
  "paths.places.19-Luxor-complex/BGQ6JNX2-68",
  "paths.places.19-Luxor-complex/BGQ6JNX2-69",
  "paths.places.19-Luxor-complex/BGQ6JNX2-70",
  "paths.places.19-Luxor-complex/BGQ6JNX2-71",
  "paths.places.20-Koptos/BGQ6JNX2-64",
  "paths.places.21-Dendera/BGQ6JNX2-63",
  "paths.places.24-Panopolis/BGQ6JNX2-159",
  "paths.places.24-Panopolis/BGQ6JNX2-161",
  "paths.places.24-Panopolis/BGQ6JNX2-160",
  "paths.places.28-Hermopolis-Magna/BGQ6JNX2-58",
  "paths.places.28-Hermopolis-Magna/BGQ6JNX2-59",
  "paths.places.36-Pelusium/BGQ6JNX2-189",
  "paths.places.36-Pelusium/BGQ6JNX2-88",
  "paths.places.36-Pelusium/BGQ6JNX2-89",
  "paths.places.36-Pelusium/BGQ6JNX2-90",
  "paths.places.38-Alexandria/BGQ6JNX2-1",
  "paths.places.53-Antinoupolis/BGQ6JNX2-52",
  "paths.places.53-Antinoupolis/BGQ6JNX2-53",
  "paths.places.53-Antinoupolis/BGQ6JNX2-54",
  "paths.places.53-Antinoupolis/BGQ6JNX2-55",
  "paths.places.58-Esna/BGQ6JNX2-169",
  "paths.places.58-Esna/BGQ6JNX2-76",
  "paths.places.68-Pbou/paths.places.68",
  "paths.places.70-Hermonthis/BGQ6JNX2-74",
  "paths.places.72-Deir-Ambra-Adra/BGQ6JNX2-177",
  "paths.places.73-Bawit/BGQ6JNX2-142",
  "paths.places.73-Bawit/BGQ6JNX2-143",
  "paths.places.75-Apa-Jeremiah/BGQ6JNX2-126",
  "paths.places.75-Apa-Jeremiah/BGQ6JNX2-127",
  "paths.places.74-Naqlun/BGQ6JNX2-131b",
  "paths.places.74-Naqlun/BGQ6JNX2-131a",
  "paths.places.74-Naqlun/BGQ6JNX2-131c",
  "paths.places.78-Kellia/BGQ6JNX2-114",
  "paths.places.78-Kellia/BGQ6JNX2-115",
  "paths.places.78-Kellia/BGQ6JNX2-116",
  "paths.places.78-Kellia/BGQ6JNX2-117",
  "paths.places.87-Medinet-Habu/BGQ6JNX2-72",
  "paths.places.87-Medinet-Habu/BGQ6JNX2-73",
  "paths.places.88-Petemout/BGQ6JNX2-66",
  "paths.places.88-Petemout/BGQ6JNX2-67",
  "paths.places.89-Ostrakine/BGQ6JNX2-92",
  "paths.places.89-Ostrakine/BGQ6JNX2-93",
  "paths.places.92-Deir-el-Balaiza/BGQ6JNX2-148",
  "paths.places.96-Philae/BGQ6JNX2-78",
  "paths.places.96-Philae/BGQ6JNX2-79",
  "paths.places.96-Philae/BGQ6JNX2-80",
  "paths.places.97-Deir-el-Kubaniya/BGQ6JNX2-174",
  "paths.places.101-Tebtynis/BGQ6JNX2-47",
  "paths.places.106-Karanis/BGQ6JNX2-191",
  "paths.places.104-Medinet-Madi/BGQ6JNX2-39",
  "paths.places.104-Medinet-Madi/BGQ6JNX2-40",
  "paths.places.104-Medinet-Madi/BGQ6JNX2-41",
  "paths.places.104-Medinet-Madi/BGQ6JNX2-42",
  "paths.places.104-Medinet-Madi/BGQ6JNX2-43",
  "paths.places.104-Medinet-Madi/BGQ6JNX2-44",
  "paths.places.112-Monastery-of-Shenoute-at-Atripe/BGQ6JNX2-150",
  "paths.places.112-Monastery-of-Shenoute-at-Atripe/BGQ6JNX2-151",
  "paths.places.112-Monastery-of-Shenoute-at-Atripe/BGQ6JNX2-152a",
  "paths.places.112-Monastery-of-Shenoute-at-Atripe/BGQ6JNX2-152b",
  "paths.places.112-Monastery-of-Shenoute-at-Atripe/BGQ6JNX2-154",
  "paths.places.113-Red-Monastery-at-Atripe/paths.places.113",
  "paths.places.114-Kellis/BGQ6JNX2-85",
  "paths.places.115-Bagawat/BGQ6JNX2-86",
  "paths.places.115-Bagawat/BGQ6JNX2-87",
  "paths.places.116-Abu-Mina/BGQ6JNX2-16",
  "paths.places.116-Abu-Mina/BGQ6JNX2-17",
  "paths.places.116-Abu-Mina/BGQ6JNX2-18",
  "paths.places.116-Abu-Mina/BGQ6JNX2-19",
  "paths.places.116-Abu-Mina/BGQ6JNX2-20",
  "paths.places.116-Abu-Mina/BGQ6JNX2-21a1",
  "paths.places.116-Abu-Mina/BGQ6JNX2-21a2",
  "paths.places.116-Abu-Mina/BGQ6JNX2-21a3",
  "paths.places.116-Abu-Mina/BGQ6JNX2-21b",
  "paths.places.116-Abu-Mina/BGQ6JNX2-21b1",
  "paths.places.116-Abu-Mina/BGQ6JNX2-22",
  "paths.places.116-Abu-Mina/BGQ6JNX2-23",
  "paths.places.116-Abu-Mina/BGQ6JNX2-24",
  "paths.places.116-Abu-Mina/BGQ6JNX2-25",
  "paths.places.116-Abu-Mina/BGQ6JNX2-26",
  "paths.places.116-Abu-Mina/BGQ6JNX2-27",
  "paths.places.116-Abu-Mina/BGQ6JNX2-28a",
  "paths.places.116-Abu-Mina/BGQ6JNX2-28b",
  "paths.places.116-Abu-Mina/BGQ6JNX2-30",
  "paths.places.116-Abu-Mina/BGQ6JNX2-31",
  "paths.places.116-Abu-Mina/BGQ6JNX2-103",
  "paths.places.116-Abu-Mina/BGQ6JNX2-104",
  "paths.places.116-Abu-Mina/BGQ6JNX2-105",
  "paths.places.117-Marina-el-Alamein/BGQ6JNX2-8",
  "paths.places.119-Dionysias/BGQ6JNX2-46",
  "paths.places.122-Hawara/BGQ6JNX2-49",
  "paths.places.143-Marea/BGQ6JNX2-9",
  "paths.places.144-Babylon/BGQ6JNX2-33",
  "paths.places.144-Babylon/BGQ6JNX2-34",
  "paths.places.144-Babylon/BGQ6JNX2-122",
  "paths.places.144-Babylon/BGQ6JNX2-123a",
  "paths.places.144-Babylon/BGQ6JNX2-123b",
  "paths.places.169-Manqabad/BGQ6JNX2-144",
  "paths.places.169-Manqabad/BGQ6JNX2-145",
  "paths.places.169-Manqabad/BGQ6JNX2-146",
  "paths.places.173-Dakhleh/BGQ6JNX2-181",
  "paths.places.176-Deir-abu-Matta/BGQ6JNX2-180",
  "paths.places.182-Karnak/BGQ6JNX2-166",
  "paths.places.182-Karnak/BGQ6JNX2-167",
  "paths.places.188-Pharan/BGQ6JNX2-95",
  "paths.places.188-Pharan/BGQ6JNX2-96a",
  "paths.places.188-Pharan/BGQ6JNX2-96b",
  "paths.places.188-Pharan/BGQ6JNX2-97",
  "paths.places.188-Pharan/BGQ6JNX2-98",
  "paths.places.188-Pharan/BGQ6JNX2-99",
  "paths.places.188-Pharan/BGQ6JNX2-100",
  "paths.places.205-Wadi-Natrun-Baramus/BGQ6JNX2-118",
  "paths.places.206-Wadi-Natrun-Syrians/BGQ6JNX2-119",
  "paths.places.208-Wadi-Natrun-Macarius/BGQ6JNX2-121",
  "paths.places.215-Deir-Abu-Hennes/BGQ6JNX2-141",
  "paths.places.217-Deir-al-Dik/BGQ6JNX2-51",
  "paths.places.338-Taposiris-Magna/BGQ6JNX2-3",
  "paths.places.338-Taposiris-Magna/BGQ6JNX2-4",
  "paths.places.338-Taposiris-Magna/BGQ6JNX2-5",
  "paths.places.338-Taposiris-Magna/BGQ6JNX2-185",
  "paths.places.367-Deir-Mar-Tumas/BGQ6JNX2-158",
  "paths.places.368-Upper-Ansina/BGQ6JNX2-137",
  "paths.places.368-Upper-Ansina/BGQ6JNX2-138",
  "paths.places.368-Upper-Ansina/BGQ6JNX2-139",
  "paths.places.368-Upper-Ansina/BGQ6JNX2-56",
  "paths.places.370-Hilwan/BGQ6JNX2-35",
  "paths.places.370-Hilwan/BGQ6JNX2-36",
  "paths.places.370-Hilwan/BGQ6JNX2-37",
  "paths.places.370-Hilwan/BGQ6JNX2-38",
  "paths.places.374-Deir-el-Matmar/BGQ6JNX2-168",
  "paths.places.380-Deir-Mar-Buqtur/BGQ6JNX2-164",
  "paths.places.380-Deir-Mar-Buqtur/BGQ6JNX2-165a",
  "paths.places.380-Deir-Mar-Buqtur/BGQ6JNX2-165b",
  "paths.places.415-Abu-Fana/BGQ6JNX2-134",
  "paths.places.415-Abu-Fana/BGQ6JNX2-135",
  "paths.places.415-Abu-Fana/BGQ6JNX2-136",
  "paths.places.416-Deir-al-Fakhuri/BGQ6JNX2-171",
  "paths.places.416-Deir-al-Fakhuri/BGQ6JNX2-172",
  "paths.places.417-Abu-Shaar/BGQ6JNX2-187",
  "paths.places.419-Ain-el-Hayz/BGQ6JNX2-83",
  "paths.places.420-Gezira-el-Faraun/BGQ6JNX2-101",
  "paths.places.421-Hawwariya/BGQ6JNX2-11",
  "paths.places.421-Hawwariya/BGQ6JNX2-12",
  "paths.places.422-Kalabasa/BGQ6JNX2-82",
  "paths.places.423-Kom-Namrud/BGQ6JNX2-132",
  "paths.places.423-Kom-Namrud/BGQ6JNX2-133",
  "paths.places.424-El-Tor/BGQ6JNX2-188",
  "paths.places.425-Tuphium/BGQ6JNX2-75",
];
